import React, { useEffect, useState } from "react";
import { Table, Modal, Form, Input, InputNumber, Button, message, Popconfirm, Card, Tooltip } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import Service from "../../service";
import { hideAuthLoader } from "../../appRedux/actions";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import "./karma.css";
import "./reward.css";


const CategoryManager = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [editId, setEditId] = useState(null);
    const Search = Input.Search;
    const [searchText, setsearchText] = useState("");



    const dispatch = useDispatch()

    // Show modal
    const showModal = () => {
        setIsModalVisible(true);
    };

    // Handle form submission
    const handleAddCategory = async (values) => {
        try {
            const response = await Service.makeAPICall({
                methodName: editId == null ? Service.postMethod : Service.putMethod,
                api_url: editId == null ? Service.wafflecategry : Service.wafflecategry + '/' + editId,
                body: {
                    category: values?.category,
                    waffle_count: values?.waffle_count
                }
            });
            if (!response.data.success) {
                message.error(response.data.message);

            }
            if (response.data.success) {
                dispatch(hideAuthLoader());
                // console.log(response.data.data,'performance')
                message.success(response.data.message);

                form.resetFields();
                wafflecategry()
                setIsModalVisible(false)
                setEditId(null)
                // setKarmaistoryData(response.data.data);
            }
        } catch (error) {
            console.error("Failed to create category:", error);
        }

    };

    // Table columns
    const columns = [
        {
            title: "Waffle Category",
            dataIndex: "category",
            key: "category",
        },
        {
            title: "Waffle Count",
            dataIndex: "waffle_count",
            key: "waffle_count",
        },
        {
            title: "Created Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (text, record) => (
                <>
                    { moment(record?.createdAt).format("DD MMM YYYY") }
                </>
            )

        },
        {
            title: "Actions",
            dataIndex: "action",
            render: (text, record) => (
                <div style={ { display: "flex", flexWrap: "wrap" } }>
                    <Tooltip title="Edit">
                        <Button type="link" className="edit">
                            <EditOutlined
                                style={ { fontSize: "18px" } }
                                onClick={ () => {
                                    wafflecategryDetail(record._id)
                                    setEditId(record._id);



                                    // setFlag(true);
                                } }
                            />
                        </Button>
                    </Tooltip>
                    <Popconfirm
                        className="popconfirm"
                        title="Are you sure to delete?"
                        okText="Yes"
                        cancelText="No"
                        onConfirm={ () => wafflecategryDelete(record._id) }
                        style={ { textAlign: 'center' } }
                    >
                        <Tooltip title="Delete">
                            <Button type="link" className="delete">
                                <DeleteOutlined style={ { fontSize: "18px" } } />
                            </Button>
                        </Tooltip>
                    </Popconfirm>



                </div>
            ),
        },

    ];



    const wafflecategry = async () => {
        try {


            const response = await Service.makeAPICall({
                methodName: Service.getMethod,
                api_url: Service.wafflecategry + '?search=' + searchText,
                // body:searchRef.current.state?.value?.length <1?"":searchRef.current.state?.value
            });

            if (response.status) {
                dispatch(hideAuthLoader());
                // console.log(response.data.data,'performance');
                setSelectedCategories(response?.data?.data)

                // setKarmaistoryData(response.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch rewards:", error);
        }
    };
    const wafflecategryDetail = async (id) => {
        try {
            const response = await Service.makeAPICall({
                methodName: Service.getMethod,
                api_url: Service.wafflecategry + '/' + id,
            });
            //   if (!response.data.success){
            //     message.error(response.data.message);

            // }
            if (response.data.success) {
                dispatch(hideAuthLoader());
                // console.log(response.data.data,'performance');
                // setSelectedCategories(response?.category,'response?.data?.data?.category');
                // message.success("");

                form.setFieldsValue({
                    waffle_count: response?.data?.data?.waffle_count,
                    category: response?.data?.data?.category

                });
                showModal()
                // setKarmaistoryData(response.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch rewards:", error);
        }
    };


    const wafflecategryDelete = async (id) => {
        try {
            const response = await Service.makeAPICall({
                methodName: Service.deleteMethod,
                api_url: Service.wafflecategry + '/' + id,
            });
            //   if (!response.data.success){
            //     message.error(response.data.message);

            // }
            if (response.data.success) {
                dispatch(hideAuthLoader());
                message.success("Waffle Category Deleted");
                wafflecategry()
                // setKarmaistoryData(response.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch rewards:", error);
        }
    };
    useEffect(() => {
        // if(searchText==''){
        wafflecategry()
        // }

    }, [])
    // useEffect(()=>{},)
    return (

        <Card className='karma-card-wrapper employee-card'>
            <div className=" inout-header text-left">
                <h2>Waffle Category </h2>
                <div className="header-btns">
                    <Button type="primary" icon={ <PlusOutlined /> } onClick={ showModal } className="redeem-button">
                        Add Waffle Category
                    </Button>
                </div>
            </div>
            <Card className="main-content-wrapper" >

                <div className="search-wrapper">
                    <Search
                        placeholder="Search..."
                        onSearch={ wafflecategry }
                        onChange={ (e) => { setsearchText(e.target.value) } }
                        //   onKeyUp={ resetSearchFilter }
                        style={ { width: 200 } }
                        className="mr2"
                    />
                    <div className="filter-btns-wrapper">

                    </div>
                </div>
                <div className="main-table-wrapper">

                    {/* Category Table */ }
                    <Table
                        pagination={ {
                            showSizeChanger: true,
                            ...selectedCategories,
                        } }
                        dataSource={ selectedCategories }
                        columns={ columns } rowKey="category"
                        footer={ () => { return `Total Categories ${selectedCategories.length}` } } />
                </div>
            </Card>

            {/* Add Category Modal */ }
            <Modal
                title={ `${editId == null ? "Add" : "Update"} Category` }
                width={ 800 }
                visible={ isModalVisible }
                onCancel={ () => {
                    setIsModalVisible(false);
                    form.resetFields();
                    setEditId(null);
                } }
                footer={ [
                    <Button
                        key="cancel"
                        className="delete-btn"
                        onClick={ () => {
                            setIsModalVisible(false);
                            form.resetFields();
                            setEditId(null);
                        } }
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="clear"
                        className="delete-btn"
                        onClick={ () => {
                            form.resetFields();
                            setEditId(null);
                        } }
                    >
                        Reset
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        htmlType="submit"
                        onClick={ () => form.submit() }
                    >
                        { editId == null ? "Add" : "Update" } Category
                    </Button>,
                ] }
            >
                <Form form={ form } layout="vertical" onFinish={ handleAddCategory }>
                    <div className="main-form-wrapper">
                        <div className="form-container">
                            <div className="form-row">
                                <div className="form-col">
                                    <div className="form-item">
                                        <Form.Item
                                            label="Category"
                                            name="category"
                                            rules={ [{ required: true, message: "Please enter a category name" }] }
                                        >
                                            <Input placeholder="Enter category name" />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="form-col">
                                    <div className="form-item">
                                        <Form.Item
                                            label="Waffle Count"
                                            name="waffle_count"
                                            rules={ [{ required: true, message: "Please enter a waffle count" }] }
                                        >
                                            <InputNumber
                                                min={ 1 }
                                                className="full-width"
                                                placeholder="Enter waffle count"
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal>
        </Card>

    );
};

export default CategoryManager;
